import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

import { Legend, LegendChartType } from './types';

type CustomLegendsProps = {
  legends: Legend[];
};

export const LegendWrapper = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
`;

export const LegendSquare = styled.div`
  border-radius: 4px;
  border: 1px solid;
  border-color: ${cbSemanticCssVars.borderPrimary};
  height: 12px;
  width: 12px;
  background-color: ${({ color }) => color ?? 'red'};
`;

export const LegendLine = styled.div`
  border-radius: 4px;
  height: 2px;
  width: 12px;
  background-color: ${({ color }) => color ?? 'red'};
`;

export const CustomLegend = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const CustomLegends = ({ legends }: CustomLegendsProps) => (
  <LegendWrapper>
    {legends?.map((entry, index) => (
      <CustomLegend key={`item-${index}`}>
        {entry.type === LegendChartType.BAR && <LegendSquare color={entry.color} />}
        {entry.type === LegendChartType.LINE && <LegendLine color={entry.color} />}
        <T.Body3>{entry.value}</T.Body3>
      </CustomLegend>
    ))}
  </LegendWrapper>
);

export default CustomLegends;
